<template>
  <div class="contents">
    <router-view />
  </div>
</template>

<script>
import "./assets/css/global.css";

export default {
  name: "App"
};
</script>

<style>
html,
body,
.contents {
  width: 100%;
  margin: 0px;
  padding: 0px;
  background-color: #140a1e;
}
</style>



// WEBPACK FOOTER //
// src/App.vue